import request from '@/http/request'

export const getTunnelMachineQuery = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/page`,
    params
  )
}

export const tunnelMachineSave = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/add`,
    params,
    {
      hiddenError: true
    }
  )
}

export const tunnelMachineUpdate = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/update`,
    params,
    {
      hiddenError: true
    }
  )
}
export const tunnelMachineModifyStatus = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/modify_status/batch`,
    params
  )
}

export const getAllTunnelMachineCode = params => {
  return request.get(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/list_all_machine_code`,
    {
      params
    }
  )
}

export const getSiteTypeAndName = () => {
  return request.get(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/getSiteTypeAndName`
  )
}

export const getSiteTypeOrNameOrPlant = params => {
  return request.get(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/getSiteTypeOrNameOrPlant`,
    { params }
  )
}

export const exportTunnelPage = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/exportTunnelPage`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const getRirdPlant = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/getPlants`)
}

export const getStoreQuery = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-store-configuration/page`, params)
}

export const storeSave = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-store-configuration/add`, params, {
    hiddenError: true
  })
}

export const storeModifyStatus = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-store-configuration/modify_status/batch`,
    params
  )
}

export const getAllStoreCode = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-store-configuration/list_all_store_code`, {
    params
  })
}
